"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ipAddress = exports.ipAddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
var macAddress = exports.macAddress = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/;
var version = exports.version = /^(\d+\.)?(\d+\.)?(\d+\.)?(\*|\d+)$/;
var number = exports.number = /^[0-9]*$/;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/regexp.js
 ** module id = 181
 ** module chunks = 0
 **/